import classNames from "classnames";
import _ from "lodash";
import { PureComponent as Component } from "react";
import { Link } from "react-router-dom";
import { Alert, Button, Col, Row } from "reactstrap";

import BottomSection from "../BottomSection";

import propTypes from "prop-types";
import ModalSnapPay from "../../Modals/ModalSnapPay";
import ShareSocialSection from "../../PageProductDetails/Detail/ShareSocialContainer";
import SneakerInfoSection from "./SneakerInfoContainer";

/* FROM OLD CODE */
import { connect } from "react-redux";
import { doFetchProfile } from "../../../actions/authAction";
import {
  doFetchProductAddon,
  doGetVoucherCode,
  doPostAkulakuPayment,
  doPostApplyVoucher,
  doPostAtomePayment,
  doPostKredivoPayment,
  doPostMidtransPayment,
  doPostPayments,
  doPostXenditPayment
} from "../../../actions/paymentAction";
import {
  doFetchCities,
  doFetchCountries,
  doFetchProvinces,
  doPostShippingCost
} from "../../../actions/postalCodeAction";
import { validateUmbre } from "../../../config/umbre";
import {
  AKULAKU,
  ATOME,
  BANKTRANSFER,
  BCA_CREDIT_CARD,
  BCA_INSTALLMENTS,
  BCA_VA,
  BNI_VA,
  BRI_VA,
  CREDITCARD,
  DEFAULT_CREDIT_CARD,
  FULLWALLET,
  GOPAY,
  KREDIVO,
  MANDIRI_CREDIT_CARD,
  MANDIRI_DEBIT_CARD,
  BNI_CREDIT_CARD,
  BNI_DEBIT_CARD,
  MANDIRI_VA,
  PERMATA_VA,
  VIRTUALACCOUNT,
  // KREDIVO_INSTALLMENTS_TYPES,
  getAdmFees
} from "../../../constants/paymentMethods";
import { isNumeric } from "../../../helpers/regex";
import { VOUCHER_COURIER_TYPE, VOUCHER_PRODUCT_TYPE, convertToRupiah, parsePhone, parsePhoneCode } from "../../../utils";
import Loading from "../../Loading";
import { ModalAlert, ModalOutOfStock } from "../../Modals";

import UserBalanceInfoModal from "../UserBalanceInfoModal";

const DEFAULT_INSTALLMENT_TYPE = "30_days";
const VOUCHER_APPLIED_MSG = "Voucher berhasil diterapkan.";
const OUT_OF_STOCK_MSG = "Sorry, someone else bought this product!";
const PRICE_CHANGED_MSG =
  "This product's price has changed! Please check the new price before checking out.";
const ASKING_PRICE_UP = "PRICE_UP";
const ASKING_PRICE_DOWN = "PRICE_DOWN";

const NextArrow = props => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    ></div>
  );
};

const PrevArrow = props => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    ></div>
  );
};
const previewSettings = {
  arrows: true,
  autoplay: true,
  infinite: true,
  // fade:true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  lazyLoad: true,
  dots: false,
  swipe: false
};
const thumbnailSettings = {
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  autoplay: false,
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1
};

const EVENT_VOUCHER = ["MANDIRIDEBITCB20"];

class Detail extends Component {
  constructor(props) {
    super(props);
    const _uniqueAmountDef = this._generateUniqueAmount(); /* FROM OLD CODE */
    this.state = {
      currentIndex: 0,
      modalVisible: false,
      /* FROM OLD CODE */
      _alias: "",
      _fullName: "",
      _phoneNumber: "",
      _alamat: "",
      _notes: "",
      _phone: "",
      _phoneSelected: null,
      _phoneCodeSelected: null,
      _phoneList: [{ value: "", label: "Code*", code3: "" }],
      _countrySelected: null,
      // _countryCodeSelected: null,
      _countryCodeSelected: "IDN",
      _province: "",
      _provinceSelected: null,
      _city: "",
      _citySelected: null,
      _voucherInput: "",
      // _voucherInput: "KOPIGOODDAY",
      _voucherValidated: null,
      _countryList: [
        { value: "", label: "Country*", code3: "", phone_code: null }
      ],
      _provinceList: [{ value: "", label: "Province*" }],
      _cityList: [{ value: "", label: "City*" }],
      _postalCode: "",
      _paymentType: props.currency === "IDR" ? BCA_VA : DEFAULT_CREDIT_CARD,
      _sell: {
        ...this.props.sell,
        asking_price: parseFloat(this.props.sell.asking_price),
        subsidy_price: this.props.sell.subsidy_price? parseInt(this.props.sell.subsidy_price) : 0
      },
      // _price:parseFloat(this.props.sell.asking_price),
      _uniqueAmount: _uniqueAmountDef,
      _uniqueAmountDef,
      _shippingFee: 0,
      _administrationFee: 0,
      _discount: 0,
      _installmentsList: [],
      _installmentsType: DEFAULT_INSTALLMENT_TYPE,
      _additionalProducts: [],
      _isPickGoodDay: false,
      // _isAddonProduct:false,
      // _kredivoCollapse:false,
      // _virtualAccountCollapse: false,
      // _toa:false,
      _processed: false,
      _submitPayment: false,
      _validationProcess: false,
      _shouldRedirect: false,
      _isValidVoucher: false,
      _error: null,
      _stillfetchCity: false,
      _id_shipping: null,
      cekShipping: false,
      modalShipping: false,
      addingShipping: false,
      shippingTmp: null,
      umbreShipping: false,
      _productPromo: 0,
      _umbreEnabled: false,
      _kickAmount: 0,
      _balance: "",
      walletPayment: false,
      openModal: false,
      isOpenOutOfStockModal: false,
      _modalOutOfStockMsg: OUT_OF_STOCK_MSG,
      _askingPriceStatus: null,
      _snapPay: {
        isOpen: false,
        invoiceNumber: null,
        trxToken: null,
        redirectUrl: null,
        externalUrl: null,
        expiredAt: null
      },
      _isErrorShippingFetch: false,
      creditDebitOnly: false,
      sellerCredit: 0,
      kickPoints: 0,
      sellerCreditUsage: 0,
      kickPointsUsage: 0,
      balanceUsage: 0, //kick credit
      isCreditUse: false,
      isUseKickPoints: false,
      isOpenModalInfo: false
    };
    this.changeImage = this.changeImage.bind(this);
    this._handleGoto = this._handleGoto.bind(this);
    this.handleModalAlert = this.handleModalAlert.bind(this);

    /* FROM OLD CODE */
    this._handleChange = this._handleChange.bind(this);
    this._handleSelectPhoneChange = this._handleSelectPhoneChange.bind(this);
    this._handleSelectCountryChange = this._handleSelectCountryChange.bind(
      this
    );
    this._handleSelectProvinceChange = this._handleSelectProvinceChange.bind(
      this
    );
    this._handleSelectCityChange = this._handleSelectCityChange.bind(this);
    this._handlePaymentTypeChange = this._handlePaymentTypeChange.bind(this);
    this._onSubmit = this._onSubmit.bind(this);
    this._applyVoucher = this._applyVoucher.bind(this);
    this._handleClearVoucher = this._handleClearVoucher.bind(this);
    this._handleUmbreShippingCheckedChange = this._handleUmbreShippingCheckedChange.bind(
      this
    );
    this._handleAdditionalChange = this._handleAdditionalChange.bind(this);
    this._handleKickAmount = this._handleKickAmount.bind(this);
    // this._handleWalletPayment = this._handleWalletPayment.bind(this);
    // this._handleChangeTerms=this._handleChangeTerms.bind(this);

    // modal purpose
    this._checkout = this._checkout.bind(this);
    this.closeModalShipping = this.closeModalShipping.bind(this);
    this.onChooseShipping = this.onChooseShipping.bind(this);
    this.toggleVirtualAccount = this.toggleVirtualAccount.bind(this);
  }

  changeImage(currentIndex) {
    this.setState({ currentIndex: currentIndex });
  }

  _handleGoto(e, currentIndex) {
    e.preventDefault();
    this.setState({ currentIndex: currentIndex });
  }

  handleModalAlert() {
    this.setState({
      modalVisible: !this.state.modalVisible
    });
  }

  onToggleBalanceInfo = () => {
    this.setState({ isOpenModalInfo: !this.state.isOpenModalInfo })
  }

  /* FROM OLD CODE */
  async componentDidMount() {
    const shipping_selected = this.props.latestShipping;
    this.fetchKredivoInstallments();
    this.props.doFetchProductAddon();
    this.props.getProfile();
    // this._buildProvinceOptions();
    //apply KOPIGOODDAY voucher
    // this._applyVoucher();
    if (shipping_selected) {
      const codeArea = parsePhoneCode(shipping_selected.phone_number);

      await this.setState(
        {
          _alias: shipping_selected.alias,
          _fullName: shipping_selected.full_name,
          _phone: shipping_selected.phone_number ? codeArea : "",
          _phoneNumber: shipping_selected.phone_number
            ? parsePhone(shipping_selected.phone_number, true, codeArea)
            : 0,
          _alamat: shipping_selected.street_address,
          _notes: shipping_selected.note,
          _province: shipping_selected.province,
          _postalCode: shipping_selected.postal_code,
          _countryCodeSelected: shipping_selected.country,
          _stillfetchCity: true,
          _city: shipping_selected.city,
          _id_shipping: shipping_selected.id
        },
        () => {
          const _shippingTmp = {
            _alias: this.state._alias,
            _fullName: this.state._fullName,
            _phone: this.state._phone,
            _phoneNumber: this.state._phoneNumber,
            _alamat: this.state._alamat,
            _notes: this.state._notes,
            _province: this.state._province,
            _postalCode: this.state._postalCode,
            _city: this.state._city,
            _id_shipping: this.state._id_shipping
          };
          this.setState({
            shippingTmp: _shippingTmp
          });
          // calculate shipping after countries & provinces fetched successfully (cdu process).
          // this._calculateShippingFee(this._getProvinceId());
          // this._buildCountryOptions();
        }
      );
    }
    this.props.getCountries();
  }

  componentDidUpdate(prevProps, prevState) {
    const {id} = this.props.dataAuth.userdata
    const shippingHistory = this.props.dataPostalCode.shippingHistory.data.filter(item => item.user_id === id);
    const { voucherCode, productAddon } = this.props;
    const { _balance, sellerCredit, kickPoints, kickPointsUsage, sellerCreditUsage, balanceUsage, isCreditUse, isUseKickPoints } = this.state;
    const totalUsageAllBalance = sellerCreditUsage + balanceUsage + kickPointsUsage;
    const remainingPayment = this._getTotal() - totalUsageAllBalance;

    if (
      prevProps.productAddon.isFetch &&
      prevProps.productAddon.isFetch !== productAddon.isFetch
    ) {
      const { data, error, status_code } = productAddon;
      if (!error && status_code === 200 && data) {
        const addonManipulates = data.map(item => {
          var addons = Object.assign({}, item);
          addons.isSelected = false;
          addons.price = parseInt(item.price);
          addons.displayName = item.display_name;
          addons.signedUrl = item.img_url;
          if (item.categories.length > 0) {
            let newCategory = [];
            item.categories.map(category => {
              newCategory.push(category.name.toLowerCase());
            });
            addons.visible = newCategory;
          } else addons.visible = "*";

          // if(item.name === "GOODDAYFREEZE1-BLUE5"){
          //   return {
          //     ...addons,
          //     isSelected: true
          //   }
          // }
          return addons;
        });
        this.setState({ _additionalProducts: addonManipulates });
      }
    }

    if (prevProps.currency !== this.props.currency) {
      this.setState({
        _paymentType: this.props.currency === "IDR" ? BCA_VA : DEFAULT_CREDIT_CARD
      });
    }

    //After fetch countries done.
    if (
      prevProps.dataCountries.isFetch &&
      prevProps.dataCountries.isFetch !== this.props.dataCountries.isFetch
    ) {
      const { error } = this.props.dataCountries;
      if (!error) {
        this._buildCountryOptions();
      }
    }

    //After fetch provinces done.
    if (
      prevProps.dataProvinces.isFetch &&
      prevProps.dataProvinces.isFetch !== this.props.dataProvinces.isFetch
    ) {
      const { error } = this.props.dataProvinces;
      if (!error) {
        this._buildProvinceOptions(this.state._countryCodeSelected);
        this._toggleUmbreEnabled(this._getProvinceId(), this.state._city);
      }
    }

    //After fetch cities done.
    if (
      prevProps.dataCities.isFetch &&
      prevProps.dataCities.isFetch !== this.props.dataCities.isFetch
    ) {
      const { dataCities, dataProvinces } = this.props;
      if (!dataCities.error) {
        this._buildCityOptions(
          this.state._countryCodeSelected,
          this._getProvinceId()
        );
      }
    }

    if (shippingHistory.status_code === 200 && this.state.cekShipping) {
      this.setState({
        cekShipping: false,
        modalShipping: shippingHistory.data.length === 0 ? false : true
      });
      if (shippingHistory.data.length === 0) {
        this.onChooseShipping(null);
      }
    }

    if (prevProps.voucherCode.isFetch !== voucherCode.isFetch) {
      if (voucherCode.code) {
        this.setState(
          {
            _voucherInput: voucherCode.code
          },
          () => {
            this._applyVoucher();
          }
        );
      }
    }

    //balance user
    const { userdata } = this.props.dataAuth;
    if (prevProps.dataAuth.userdata.isFetch !== userdata.isFetch) {
      if (userdata.isFetch && !this.state._isFetch) {
        this.setState({
          _isFetch: userdata.isFetch
        });
      } else if (!userdata.isFetch && this.state._isFetch) {
        this.setState({
          _isFetch: !this.state._isFetch,
          _balance: parseFloat(userdata.balance),
          sellerCredit: parseFloat(userdata.balance_with_fee),
          kickPoints: parseFloat(userdata.locked_balance)
        });
      }
    }

    if (prevProps.sell.id !== this.props.sell.id) {
      this.setState({
        _sell: {
          ...this.props.sell,
          asking_price: parseFloat(this.props.sell.asking_price)
        }
      });
    }

    if (
      prevProps.dataCouriers.isFetch &&
      prevProps.dataCouriers.isFetch !== this.props.dataCouriers.isFetch
    ) {
      const { error } = this.props.dataCouriers;
      this.setState({ _isErrorShippingFetch: error !== null });
    }

    if (
      prevProps.dataPayments.payments.isSubmit &&
      prevProps.dataPayments.payments.isSubmit !==
        this.props.dataPayments.payments.isSubmit
    ) {
      const { error } = this.props.dataPayments.payments;
      if (error) {
        const { errors, status_code } = error;
        if (errors && status_code === 422) {
          const errorOfferAmount = Object.keys(errors).find(
            key => key === "offer_amount"
          );
          if (errorOfferAmount) {
            const {
              _voucherInput,
              _voucherValidated,
              _shippingFee,
              _paymentType,
              _kickAmount,
              _sell: { asking_price }
            } = this.state;
            let _isValidVoucher = this.state._isValidVoucher;
            const newAskingPrice = parseFloat(errors.offer_amount[1].ERROR_VAR);
            const { balance } = this.props.dataAuth.userdata;

            let _discount = 0;

            if (_isValidVoucher && _voucherValidated !== null) {
              const { minimum_purchase } = _voucherValidated;
              if (parseFloat(minimum_purchase) > newAskingPrice)
                _isValidVoucher = !_isValidVoucher;
              else
                _discount = this._getVoucherAmount(
                  _voucherValidated,
                  newAskingPrice,
                  _shippingFee
                );
            }

            const _administrationFee = this._getAdmFee(
              _paymentType,
              newAskingPrice,
              _shippingFee,
              _discount
            );

            if (balance < newAskingPrice) {
              this.setState({
                walletPayment: false,
                _kickAmount: 0,
                _paymentType: BANKTRANSFER
              });
            }

            this.setState(
              {
                _sell: {
                  ...this.state._sell,
                  asking_price: newAskingPrice
                },
                _discount,
                _administrationFee,
                _isValidVoucher,
                _voucherValidated: _isValidVoucher ? _voucherValidated : null,
                _voucherInput: _isValidVoucher ? _voucherInput : "",
                openModal: !this.state.openModal,
                _modalOutOfStockMsg: PRICE_CHANGED_MSG,
                _askingPriceStatus:
                  asking_price < newAskingPrice
                    ? ASKING_PRICE_UP
                    : ASKING_PRICE_DOWN,
                _kickAmount: 0
              },
              () => {
                const {
                  _sell: { asking_price },
                  _discount,
                  _administrationFee,
                  _isValidVoucher,
                  _voucherValidated,
                  _voucherInput
                } = this.state;
              }
            );
          }
        } else if (status_code === 404) {
          this.setState({
            isOpenOutOfStockModal: true,
            _modalOutOfStockMsg: OUT_OF_STOCK_MSG
          });
        }
      }
    }

    if (prevState.isUseKickPoints !== this.state.isUseKickPoints) {
      if (this.state.isUseKickPoints) {
        if (this._getTotal() <= this.state.kickPoints) this._handleWalletPaymentCheckedChange(false, this.state._paymentType)
      }
    }
  }

  /**
   * Handle fetch kredivo installments to API.
   */
  fetchKredivoInstallments() {
    const { kredivoAvailableInstallment } = this.props.dataPayments;
    if (kredivoAvailableInstallment.status_code === 200) {
      if (kredivoAvailableInstallment.user_sell_id === this.state._sell.id) {
        const list = kredivoAvailableInstallment.data.installments.map(item => {
          return {
            value: item.id,
            label: item.name,
            monthly_installment: item.monthly_installment
          };
        });
        this.setState({
          _installmentsList: list
        });
      }
    } else {
      // Fetch now...
      // Or not show, because have been loaded from product detail page.
    }
  }

  componentWillReceiveProps(nextProps) {
    //After fetch courier cost done.
    const { umbreShipping } = this.state;
    if (
      nextProps.dataCouriers.isFetch === false &&
      nextProps.dataCouriers.isFetch !== this.props.dataCouriers.isFetch
    ) {
      if (nextProps.dataCouriers.status_code === 200) {
        let { _paymentType, _voucherValidated } = this.state;
        const {
          _sell: { id, asking_price, subsidy_price }
        } = this.state;
        const { cost } = nextProps.dataCouriers || 0;
        const _discount = this._getVoucherAmount(
          _voucherValidated,
          (asking_price - parseInt(subsidy_price)),
          cost
        );

        this.setState({
          // _shippingFee: umbreShipping ? 150000 : cost,
          _shippingFee: umbreShipping ? 0 : cost,
          _administrationFee: this._getAdmFee(
            this.state._paymentType,
            asking_price,
            cost,
            _discount
          ),
          _discount
        }, () => this._handleBalanceUsage());
      }
    }

    //After submit payment to api done.
    if (
      nextProps.dataPayments.payments.isSubmit === false &&
      this.state._submitPayment === true &&
      nextProps.dataPayments.payments.isSubmit !==
        this.props.dataPayments.payments.isSubmit
    ) {
      const { payments } = nextProps.dataPayments;
      if (!payments.error) {
        let { _paymentType } = this.state;

        if (payments.data.payment_via === "vt") {
          this.setState({
            _snapPay: {
              isOpen: true,
              invoiceNumber: payments.data.invoice_number,
              trxToken: payments.data.payment_gateway.transaction_token,
              externalUrl: payments.data.payment_gateway.redirect_url,
              expiredAt: payments.data.payment_gateway.expired_at,
              redirectUrl: `/invoices/${payments.data.invoice_number}?trx_id=${payments.data.payment_gateway.transaction_token}`,
              _processed: true,
              _shouldRedirect: true
            }
          });
        } else {
          this.setState({ _processed: true, _shouldRedirect: true }, () => {
            if (_paymentType === BANKTRANSFER || _paymentType === FULLWALLET)
              setTimeout(
                () => this._redirectBankTransfer(payments.data.invoice_number),
                3000
              );
            // else if(payments.data.payment_via === 'xnd')
            else
              setTimeout(
                () =>
                  this._redirectXendit(
                    payments.data.invoice_url,
                    payments.data.invoice_number
                  ),
                3000
              );
            // else if(payments.data.payment_via === 'vt'){
            //   setTimeout(() => this._redirectMidtransPayment(payments.data.invoice_number, payments.data.payment_gateway.transaction_token),3000)
            // }
          });
        }
      } else {
        const { error } = payments;
        let hasMessageCustom = false;
        let message = error.message;
        if (error.status_code === 500) {
          if (
            message === "User has wallet payment or disbursement still pending."
          ) {
            message =
              "Sorry, your request cannot be processed. You still have wallet payment or cash out pending.";
            hasMessageCustom = true;
          }
        }
        this.setState({
          _error: {
            ...payments.error,
            message,
            hasMessageCustom
          },
          _submitPayment: !this.state._submitPayment
        });
      }
    }
    //After checking voucher availables done.
    if (
      nextProps.dataPayments.voucher.isSubmit === false &&
      nextProps.dataPayments.voucher.isSubmit !==
        this.props.dataPayments.voucher.isSubmit
    ) {
      const { voucher } = nextProps.dataPayments;
      const {
        _sell: { 
          asking_price, 
          subsidy_price
        } 
      } = this.state;
      if (voucher.status_code === 200) {
        const {
          code,
          type,
          amount,
          deduct_type,
          minimum_purchase,
          max_amount,
          potentially_cashback,
          is_cashback
        } = voucher.data;
        const _discount = this._getVoucherAmount(
          { code, type, amount, deduct_type, max_amount, potentially_cashback, is_cashback },
          (asking_price - parseInt(subsidy_price || 0)),
          this.state._shippingFee
        );

        this.setState({
          _isValidVoucher: true,
          _voucherValidated: {
            code,
            type,
            amount,
            deduct_type,
            minimum_purchase,
            max_amount,
            potentially_cashback,
            is_cashback
          },
          _administrationFee: this._getAdmFee(
            this.state._paymentType,
            asking_price,
            this.state._shippingFee,
            _discount
          ),
          _discount,
          creditDebitOnly: EVENT_VOUCHER.includes(this.state._voucherInput && this.state._voucherInput.toUpperCase())
          ? true
          : false
        });
      } else {
        let _error = null;
        switch (voucher.error.status_code) {
          case 422:
            {
              _error = {
                errors: {
                  _voucherInput: Object.keys(voucher.error.errors)
                    .filter(err => err === "code")
                    .map(err => {
                      if (
                        voucher.error.errors[err][0] ===
                        "Voucher can only use on app."
                      ) {
                        return [
                          "Sorry this voucher can only apply through our application. You can download it in App Store or Play Store."
                        ];
                      }
                      return voucher.error.errors[err];
                    })
                },
                status_code: 422
              };
            }
            break;
          case 404:
            {
              _error = {
                errors: {
                  _voucherInput: ["Voucher tidak ditemukan."]
                },
                status_code: 422
              };
            }
            break;
          default: {
            _error = {
              errors: {
                _voucherInput: [
                  "Oopss ada error. Please inform our staff via our official Line account."
                ]
              }
            };
            break;
          }
        }
        this.setState({
          _error,
          _discount: 0,
          _voucherInput: "",
          _voucherValidated: null,
          _isValidVoucher: false
        });
      }
    }
  }

  _handleOnRetryCalculateShippingFee = e => {
    e.preventDefault();
    this._calculateShippingFee(this._getProvinceId());
  };

  _calculateShippingFee = async provinceId => {
    const { id, weight } = this.props.product;
    const addons = this.state._additionalProducts
      .filter(item => item.isSelected)
      .map(item => item.name)
      .join(" + ");
      
    let payloads = {
      destination: provinceId,
      product_variant_id: id,
      weight: weight || 1000,
      courier: "FLAT_RATE"
    };
    if (addons) payloads = { ...payloads, product_addon: addons }
    await this.setState({
      _isErrorShippingFetch: false
    });
    this.props.getShippingFee(payloads);
  };

  /**
   * Handle redirect into next page using "bank transfer" payment type.
   * @param {string} invoice_number
   */
  _redirectBankTransfer(invoice_number) {
    this.props.history.replace(`/invoices/${invoice_number}`);
  }

  /**
   * Handle redirect into next page using "midtrans" payment type.
   * @param {string} invoice_number
   */
  _redirectMidtransPayment(invoice_number, trxToken) {
    this.props.history.replace({
      pathname: `/invoices/${invoice_number}`,
      search: `trx_id=${trxToken}`
    });
  }

  /**
   * Handle redirect into next page using "xendit" payment type.
   * @param {string} url
   * @param {string} invoice_number
   */
  _redirectXendit(url, invoice_number) {
    this.props.history.replace(`/invoices/${invoice_number}`);
    if (url) {
      const win = window.open("", "_blank");
      if (win) win.location = url;
      else window.location = url;
      // win.location=url;
    }
  }

  /**
   * Get "Biaya Layanan" value.
   * @return {float}
   */
  _getLayananPrice = () => {
    const { _administrationFee } = this.state;
    return parseFloat(_administrationFee);
  };

  /**
   * Get and calculate voucher amount.
   * @param {Object} voucherObj
   * @param {float} price
   * @param {float} courierPrice
   * @return {float}
   */
  _getVoucherAmount(voucherObj, price, courierPrice) {
    let discount = 0;

    if (voucherObj !== null) {
      if (voucherObj.deduct_type === VOUCHER_PRODUCT_TYPE) {
        if (voucherObj.type === "percentage") {
          discount = parseInt(Math.ceil((voucherObj.amount / 100) * price));
        } else {
          discount = voucherObj.amount;
        }
        discount =
          voucherObj.max_amount &&
          parseInt(discount) > parseInt(voucherObj.max_amount)
            ? voucherObj.max_amount
            : discount;
        return discount > price ? price : discount;
      } else if (voucherObj.deduct_type === VOUCHER_COURIER_TYPE) {
        if (voucherObj.type === "percentage") {
          discount = parseInt(
            Math.ceil((voucherObj.amount / 100) * courierPrice)
          );
        } else {
          discount = voucherObj.amount;
        }
        discount =
          voucherObj.max_amount &&
          parseInt(discount) > parseInt(voucherObj.max_amount)
            ? voucherObj.max_amount
            : discount;
        return discount > courierPrice ? courierPrice : discount;
      }
    }
    return discount;
  }

  /**
   * Get and calculat Administration Fee value.
   * @param {string} paymentType
   * @param {float} price
   * @param {float} courierPrice
   * @param {float} discount
   * @return {float}
   */

  _getAdmFee(paymentType, price, courierPrice, discount) {
    return getAdmFees(paymentType, price, courierPrice, discount);
  }

  /**
   * Calculate total amount.
   * @return {float}
   */
  _getTotal = () => {
    const {
      _sell: { asking_price, subsidy_price },
      _discount,
      _shippingFee
    } = this.state;
    const totalPromo = this._getTotalAddOnProduct();

    return parseFloat(asking_price + _shippingFee - _discount + this._getLayananPrice() + totalPromo - this._getWalletValue() - parseInt(subsidy_price || 0));
  };

  _getTotalAddOnProduct = () => {
    const { _additionalProducts } = this.state;
    return _additionalProducts
      .filter(item => item.active && item.isSelected)
      .reduce((current, item) => current + item.price, 0);
  };

  _getTotalWithoutWallet = () => {
    const {
      _sell: { asking_price, subsidy_price },
      _discount,
      _shippingFee
    } = this.state;
    const totalPromo = this._getTotalAddOnProduct();

    return parseFloat(asking_price + _shippingFee - _discount + this._getLayananPrice() + totalPromo - parseInt(subsidy_price || 0));
  };

  _getWalletValue = () => {
    const { _kickAmount, walletPayment } = this.state;
    const wallet = isNaN(parseFloat(_kickAmount)) ? 0 : parseFloat(_kickAmount);

    return wallet;
  };

  /**
   * Generate unique amount value.
   * @return {int}
   */
  _generateUniqueAmount() {
    return Math.floor(Math.random() * 100);
  }

  /**
   * Get Selected ProvinceId by province index.
   * @return {int}
   */
  _getProvinceId() {
    const { _province, _provinceSelected } = this.state;
    // const { data } = this.props.dataProvinces;
    // const provinceById = data.find(item => item.name == _province)
    // if (provinceById) return provinceById.id;
    if (_provinceSelected) return _provinceSelected.id;

    return 0;
  }

  _handleSelectPhoneChange(selected) {
    if (selected) {
      this.setState({
        _phone: selected.label,
        _phoneCodeSelected: selected.label,
        _phoneSelected: selected
      });
    } else {
      this.setState({
        _phoneSelected: null
      });
    }
  }

  /**
   * Handle country select value change.
   * Value will be store on _country in state as index of countries.
   * @param {Object} selected
   */
  _handleSelectCountryChange(selected) {
    if (selected) {
      this.setState(
        {
          _countryCodeSelected: selected.code3,
          _countrySelected: selected,
          _province: "",
          _provinceList: [
            { value: "", label: "Province*" },
            { value: "", label: "Loading province.." }
          ],
          _city: "",
          _cityList: [
            { value: "", label: "City*" },
            { value: "", label: "Loading city.." }
          ]
        },
        () => {
          this._buildProvinceOptions(selected.code3);
          // this.props.getProvinces(selected.code3)
        }
      );
    } else {
      this.setState({
        _countryCodeSelected: null,
        _countrySelected: null,
        _province: "",
        _provinceList: [
          { value: "", label: "Province*" },
          { value: "", label: "Loading province.." }
        ],
        _city: "",
        _cityList: [
          { value: "", label: "City*" },
          { value: "", label: "Loading city.." }
        ]
      });
    }
  }

  _handleSelectProvinceChange(selected) {
    const { _countryCodeSelected, _provinceSelected } = this.state;

    if (selected) {
      const provinceId =
        selected.value === "" ? 0 : parseInt(selected.value) + 1;

      this.setState(
        {
          _province: selected.label,
          _provinceSelected: selected,
          _city: "",
          _cityList: [
            { value: "", label: "City*" },
            { value: "", label: "Loading city.." }
          ]
        },
        () => {
          this._toggleUmbreEnabled(this._getProvinceId(), null);
          this._calculateShippingFee(this._getProvinceId());
          // this._buildCityOptions(this._getCountryId(), this._getProvinceId());
          this.props.getCities(
            _countryCodeSelected,
            selected && selected.label
          );
        }
      );
    } else {
      this.setState({
        _province: "",
        _provinceSelected: null,
        _city: "",
        _cityList: [
          { value: "", label: "City*" },
          { value: "", label: "Loading city.." }
        ]
      });
    }
  }

  _handleSelectCityChange(selected) {
    if (selected) {
      this.setState({ _citySelected: selected });
      this._toggleUmbreEnabled(this._getProvinceId(), selected && selected.id);
    } else {
      this.setState({
        _citySelected: null
      });
    }
  }

  _buildCountryOptions() {
    if (this.props.dataCountries.status_code !== 200) this.props.getCountries();
    else {
      const { data } = this.props.dataCountries;
      const {
        _countrySelected,
        _phoneSelected,
        _countryCodeSelected
      } = this.state;
      const countries = data.map((country, index) => ({
        value: index,
        label: country.name,
        code3: country.code3,
        phone_code: country.phone_code
      }));

      const getCountry = countries.find(
        item => item.code3 == this.state._countryCodeSelected
      );

      if (getCountry) {
        this.setState(
          {
            _countrySelected: getCountry
          },
          () => {
            this._buildProvinceOptions(getCountry && getCountry.code3);
            // this.props.getProvinces(getCountry && getCountry.code3)
          }
        );
      }

      const phones = data.map((phone, index) => ({
        value: index,
        label: phone.phone_code,
        code3: phone.code3
      }));

      const getPhone = phones.find(
        item =>
          item.label ==
          (_phoneSelected ? _phoneSelected.label : this.state._phone)
      );

      if (getPhone) {
        this.setState({
          _phoneSelected: getPhone
        });
      }

      this.setState({
        _countryList: [
          { value: "", label: "Country*", code3: "", phone_code: null },
          ...countries
        ],
        _phoneList: [{ value: "", label: "Code*", code3: "" }, ...phones]
      });
    }
  }

  _buildProvinceOptions(countryId = "IDN") {
    const { data, isFetch } = this.props.dataProvinces;
    const { data: dCountries } = this.props.dataCountries;
    let country = dCountries.find(item => item.code3 === countryId);
    country = country ? country.id : 1;
    let refetch = false;
    if (this.props.dataProvinces.status_code !== 200) {
      refetch = true;
    } else if (data && data.length) {
      refetch = country !== data[0].country_id;
      // console.log("id: ", country, "data[0].country_id: ", data[0].country_id, "refetch: ", refetch)
    }
    if (refetch) this.props.getProvinces(countryId);
    else {
      const { _provinceSelected, _countrySelected } = this.state;
      const provinces = data.map((province, index) => ({
        value: index,
        label: province.name,
        id: province.id
      }));
      let provinceSelected = _provinceSelected;
      let fetchCity = false;
      if (_provinceSelected == null || _provinceSelected !== null) {
        const getProvince = provinces.find(
          item => item.label == this.state._province
        );
        fetchCity = !fetchCity;
        provinceSelected = getProvince ? getProvince : null;
        // this.setState({
        //   _provinceSelected: getProvince? getProvince: null
        // }, () => {
        //   this.props.getCities(_countrySelected && _countrySelected.code3, getProvince && getProvince.label)
        // })
      }

      this.setState(
        {
          _provinceList: [{ value: "", label: "Province*" }, ...provinces],
          _provinceSelected: provinceSelected
        },
        () => {
          if (fetchCity) {
            this.props.getCities(
              _countrySelected && _countrySelected.code3,
              provinceSelected && provinceSelected.label
            );
          }
          this._calculateShippingFee(this._getProvinceId());
        }
      );
    }
  }

  _buildCityOptions = () => {
    const { data } = this.props.dataCities;
    const {
      _countrySelected,
      _provinceSelected,
      _city,
      _cityList,
      _citySelected
    } = this.state;

    if (data.length > 0) {
      const allCity = data.map((item, index) => ({
        value: index,
        label: item.name,
        id: item.id
      }));

      //checking for duplicates item
      const newCityList = _.uniqBy(allCity, "label");

      //find selected city
      const getSelectedCity = newCityList.find(item => item.label === _city);

      this.setState({
        _citySelected: getSelectedCity,
        _cityList: [{ value: "", label: "City*" }, ...newCityList]
      });

      if (getSelectedCity) {
        this._toggleUmbreEnabled(
          this._getProvinceId(),
          _citySelected && _citySelected.id
        );
      }
    }
  };

  /**
   * Handle textbox value change.
   * @param  e
   */
  _handleChange(e) {
    const lastState = { ...this.state };
    if(e.target.name === "_phoneNumber") lastState[e.target.name] = e.target.value.replace(/[^0-9]/gi,'')
     else lastState[e.target.name] = e.target.value;
    this.setState({ ...lastState });
  }

  // _handleChangeTerms(e){
  //   this.setState({_toa:e.target.checked})
  // }

  _updateState = (key, value) => {
    this.setState({ [key]: value });
  };

  /**
   * Handel virtual account collapse toggle.
   */
  toggleVirtualAccount() {
    this.setState({
      _virtualAccountCollapse: !this.state._virtualAccountCollapse
    });
  }

  /**
   * Handle Radio Input value for payment type change.
   * @param e
   */
  _handlePaymentTypeChange(e) {
    const lastState = { ...this.state };
    lastState[e.target.name] = e.target.value;
    const {
      _sell: { asking_price }
    } = this.state;

    lastState._administrationFee = this._getAdmFee(
      e.target.value,
      asking_price,
      this.state._shippingFee,
      this.state._discount
    );
    switch (e.target.value) {
      case VIRTUALACCOUNT:
      case GOPAY:
      case AKULAKU:
      case KREDIVO:
      case ATOME:
      case BCA_CREDIT_CARD:
      case CREDITCARD: {
        lastState._uniqueAmount = 0;
        break;
      }
      case FULLWALLET: {
        lastState._uniqueAmount = 0;
        lastState._kickAmount = 0;
        lastState.walletPayment = false;
        break;
      }
      default: {
        lastState._uniqueAmount = lastState._uniqueAmountDef;
        break;
      }
    }
    this.setState({ ...lastState });
  }

  toggleModalStock = () => {
    this.setState({
      openModal: !this.state.openModal
    });
  };

  _toggleModalStock = () => {
    this.setState({
      isOpenOutOfStockModal: !this.state.isOpenOutOfStockModal
    });
  };

  toggleModalAlert = () => {
    this.setState({
      openModalAlert: !this.state.openModalAlert
    });
  };

  _hasErrorForm = errors => {
    return Object.keys(errors).length > 0;
  };

  _handleKickAmount(e) {
    const _kickAmount = e.target.value
      ? `${e.target.value.replace(/^0|[^\d]+/g, "")}.00`
      : 0;
    const errors = {};
    const limit = parseInt(this._getTotalWithoutWallet()) - 100000;

    if (!isNumeric(Number(_kickAmount)) && !e.target.value)
      errors["_kickAmount"] = ["This field must be numeric."];
    else if (
      parseInt(_kickAmount) > parseInt(this.props.dataAuth.userdata.balance)
    )
      errors["_kickAmount"] = [
        "The amount entered may not exceed the Kick Credit."
      ];
    else if (parseInt(_kickAmount) > limit)
      errors["_kickAmount"] = [
        `The amount entered may not exceed IDR. ${convertToRupiah(limit)}`
      ];

    this.setState({
      _kickAmount: _kickAmount,
      _error: {
        errors,
        status_code: this._hasErrorForm(errors) ? 422 : null
      }
    });
  }

  /**
   * Handle determines umbre shipping promo availables.
   * By province id and city id given.
   * @param provinceId
   * @param cityId
   */
  _toggleUmbreEnabled(provinceId, cityId) {
    const { _additionalProducts } = this.state;
    const _umbreEnabled = validateUmbre(provinceId, cityId);
    if (_umbreEnabled !== this.state.umbreShipping && !_umbreEnabled) {
      this._onUmbreShippingValueChange(_umbreEnabled);
      this._calculateShippingFee(provinceId);
    }
    this.setState({
      _umbreEnabled,
      _additionalProducts: !_umbreEnabled
        ? _additionalProducts.map(item => ({
            ...item,
            isSelected:
              item.name && item.name.toUpperCase() === "KAXUMBRE"
                ? false
                : item.isSelected
          }))
        : _additionalProducts
    });
  }

  /**
   * Handle using umbre shipping or not.
   * It will be affect to _shippingFee and _productPromo values.
   * @param {bool} value
   */
  _onUmbreShippingValueChange = value => {
    const {
      _sell: { asking_price, subsidy_price },
      _discount,
      _paymentType
    } = this.state;

    this.setState({
      umbreShipping: value,
      _additionalProducts: this.state._additionalProducts.map(item => ({
        ...item,
        isSelected:
          item.name && item.name.toUpperCase() === "KAXUMBRE"
            ? value
            : item.isSelected
      })),
      _shippingFee: value ? 0 : this.state._shippingFee,
      _productPromo: value ? 150000 : 0,
      _discount: value
        ? this._getVoucherAmount(this.state._voucherValidated, (asking_price - parseInt(subsidy_price || 0)), 0)
        : _discount,
      _administrationFee: value
        ? this._getAdmFee(_paymentType, asking_price, 0, _discount)
        : this.state._administrationFee
    });
  };

  /**
   * Handle umbre shipping checkbox value change.
   * @param {bool} value
   */
  _handleUmbreShippingCheckedChange(value) {
    if (!value) {
      this._onUmbreShippingValueChange(value);
      this._calculateShippingFee(this._getProvinceId());
    } else if (this.state._umbreEnabled)
      this._onUmbreShippingValueChange(value);
  }

  _handleAdditionalChange = async (data, isSelected) => {
    const {
      _sell: { asking_price },
      _voucherValidated,
      _shippingFee,
      _additionalProducts,
      _paymentType,
      grandTotal,
      walletUsage,
      isNotEnoughCredit
    } = this.state;
    const addonSelected = _additionalProducts.filter(
      item => item.isSelected && item.name !== data.name
    );
    const numberOfSelected = _additionalProducts.filter(
      item =>
        item.promoType === "goodday" &&
        item.isSelected &&
        item.name !== data.name
    );
    const userBalance = this.props.dataAuth.userdata.balance;

    // const isNotEnough = _paymentType === FULLWALLET && userBalance < this._getTotal();

    const kickAmount = this._getTotalWithoutWallet() - 100000;

    await this.setState(
      {
        _additionalProducts: _additionalProducts.map(item => {
          if (data.name === item.name) {
            return {
              ...item,
              isSelected: numberOfSelected.length > 1 ? false : isSelected
            };
          }
          return item;
        }),
        _isPickGoodDay: numberOfSelected.length > 1,
        // _paymentType: isNotEnough ? MANDIRI_VA : _paymentType,
        // walletPayment:
        //   isNotEnough && _paymentType === FULLWALLET
        //     ? false
        //     : this.state.walletPayment,
        // openModalAlert: isNotEnough ? true : false
      },
      () => {
        this._calculateShippingFee(this._getProvinceId());
        this._handleBalanceUsage();
      }
    );
  };

  _handleWalletPaymentCheckedChange = (value, type = BCA_VA) => {
    const {
      _sell: { asking_price },
      _discount,
      _shippingFee,
      _balance,
      sellerCredit,
      kickPoints,
      sellerCreditUsage,
      balanceUsage,
      kickPointsUsage
    } = this.state;
    // const _balance = 2000000;
    const paymentType = value ? FULLWALLET : type;
    const isTotalGreaterThanSeller = this._getTotal() > sellerCredit;
    const totalUsageAllBalance = sellerCreditUsage + balanceUsage + kickPointsUsage;
    const remainingPayment = this._getTotal() - totalUsageAllBalance;
    const userBalanceUsage = remainingPayment > sellerCredit? (_balance > (remainingPayment - sellerCredit)? remainingPayment - sellerCredit : _balance) : 0;

    this.setState({
      walletPayment: value,
      isCreditUse: value,
      // isUseKickPoints: !value? false : this.state.isUseKickPoints,
      _kickAmount: value ? 0 : this.state._kickAmount,
      _uniqueAmount: value ? 0 : this.state._uniqueAmountDef,
      _administrationFee: this._getAdmFee(
        paymentType,
        asking_price,
        _shippingFee,
        _discount
      )
    }, () => {
      this._handleBalanceUsage();
    });
  };

  _handleKickPointCheckedChange = (value, paymentType = BCA_VA) => {
    const { _balance, sellerCredit, kickPoints, kickPointsUsage, sellerCreditUsage, balanceUsage, isCreditUse, isUseKickPoints } = this.state;
    const totalUsageAllBalance = sellerCreditUsage + balanceUsage + kickPointsUsage;
    const remainingPayment = this._getTotal() - totalUsageAllBalance;

    this.setState({ 
      isUseKickPoints: value,
      _paymentType: paymentType
    }, () => {
      this._handleBalanceUsage();
    });
  }

  _handlePaymentType = () => {
    const { _balance, sellerCredit, kickPoints, kickPointsUsage, sellerCreditUsage, balanceUsage } = this.state;
    const totalActiveBalance = sellerCreditUsage + balanceUsage + kickPointsUsage;
    const remainingPayment = this._getTotal() - totalActiveBalance;

    this.setState({ 
      _paymentType: remainingPayment > 0? this.state._paymentType : FULLWALLET
    })
  }

  //handle credit calculation
  _handleCalculation = () => {
    const { _balance, sellerCredit, kickPoints, kickPointsUsage, sellerCreditUsage, balanceUsage, isCreditUse, isUseKickPoints } = this.state;
    let remainingPayment, usageBalancePoint, usageBalanceSeller, usageBalance;

    if (isUseKickPoints && isCreditUse) {
      // Kick point split payment calculation
      const pointUsage = (kickPoints >= this._getTotal()) ? this._getTotal() : kickPoints;
      usageBalancePoint = isUseKickPoints ? pointUsage : 0;
      const priceAfterKickPointsUsage = this._getTotal() - usageBalancePoint;

      // Seller credit split payment calculation
      const sellerBalanceUsage = sellerCredit >= priceAfterKickPointsUsage ? priceAfterKickPointsUsage : sellerCredit;
      usageBalanceSeller = priceAfterKickPointsUsage > 0 ? sellerBalanceUsage : 0;
      const priceAfterSellerCreditUsage = priceAfterKickPointsUsage - usageBalanceSeller;

      // Kick credit split payment calculation
      const creditBalanceUsage = _balance >= priceAfterSellerCreditUsage ? priceAfterSellerCreditUsage : _balance;
      usageBalance = priceAfterSellerCreditUsage > 0 ? creditBalanceUsage : 0;
      remainingPayment = this._getTotal() - usageBalancePoint - usageBalanceSeller - usageBalance;
    } else if (isUseKickPoints && !isCreditUse) {
      // Kick point split payment calculation
      const pointUsage = (kickPoints >= this._getTotal()) ? this._getTotal() : kickPoints;
      usageBalancePoint = isUseKickPoints ? pointUsage : 0;
      const priceAfterKickPointsUsage = this._getTotal() - usageBalancePoint;
      remainingPayment = priceAfterKickPointsUsage;
      usageBalanceSeller = 0;
      usageBalance = 0;
    } else if (!isUseKickPoints && isCreditUse) {
      // Kick point split payment calculation
      usageBalancePoint = 0;

      // Seller credit split payment calculation
      const sellerBalanceUsage = sellerCredit >= this._getTotal() ? this._getTotal() : sellerCredit;
      usageBalanceSeller = this._getTotal() > 0 ? sellerBalanceUsage : 0;
      const priceAfterSellerCreditUsage = this._getTotal() - usageBalanceSeller;

      // Kick credit split payment calculation
      const creditBalanceUsage = _balance >= priceAfterSellerCreditUsage ? priceAfterSellerCreditUsage : _balance;
      usageBalance = priceAfterSellerCreditUsage > 0 ? creditBalanceUsage : 0;
      remainingPayment = this._getTotal() - usageBalancePoint - usageBalanceSeller - usageBalance;
    } else {
      usageBalance = 0;
      usageBalancePoint = 0;
      usageBalanceSeller = 0;
      remainingPayment = this._getTotal();
    }

    return {
      remainingPayment,
      usageBalancePoint,
      usageBalanceSeller,
      usageBalance
    }
  }

  _handleBalanceUsage = () => {
    const { _balance, sellerCredit, kickPoints, kickPointsUsage, sellerCreditUsage, balanceUsage, isCreditUse, isUseKickPoints } = this.state;
    const { remainingPayment, usageBalance, usageBalancePoint, usageBalanceSeller } = this._handleCalculation();

    this.setState({
      sellerCreditUsage: usageBalanceSeller,
      balanceUsage: usageBalance,
      kickPointsUsage: usageBalancePoint
    }, () => {
      this._handlePaymentType()
    })
  }

  _handleChangesShipping() {
    const {
      shippingTmp,
      _fullName,
      _phoneNumber,
      _city,
      _alamat,
      _postalCode
    } = this.state;
    let changes = {};
    if (shippingTmp !== null) {
      if (shippingTmp._fullName !== _fullName)
        changes["_fullName"] = ["Fullname changes"];
      if (shippingTmp._phoneNumber !== _phoneNumber)
        changes["_phoneNumber"] = ["PhoneNumber changes"];
      if (shippingTmp._alamat !== _alamat)
        changes["_alamat"] = ["Alamat changes"];
      if (shippingTmp._city !== _city) changes["_city"] = ["City changes"];
      if (shippingTmp._alamat !== _alamat)
        changes["_alamat"] = ["Alamat changes"];
      if (shippingTmp._postalCode !== _postalCode)
        changes["_postalCode"] = ["Postal Code changes"];
    }
  }

  /**
   * Handle submit button click event.
   * @param e
   */
  _onSubmit(e) {
    e.preventDefault();
    const { _shippingFee, _additionalProducts, _isAddonProduct, isCreditUse, isUseKickPoints, sellerCreditUsage, kickPointsUsage, balanceUsage } = this.state;
    this.setState({ _isPickGoodDay: false });
    const valid = this._validateForm();
    const validShipping = this._validateShipping();
    const parentDiv = document.getElementById("pageCheckoutOffer");
    const buffer = 120;
    const totalUsageWallet = parseInt(sellerCreditUsage) + parseInt(kickPointsUsage) + parseInt(balanceUsage);

    if (Object.keys(valid).length || Object.keys(validShipping).length) {
      const {
        state: { _collapseShipping, _collapsePayment }
      } = this.shippingPaymentRefs;
      if (!_collapseShipping) this.shippingPaymentRefs.shippingToggle();
      if (!_collapsePayment) this.shippingPaymentRefs.paymentToggle();
      if (parentDiv) {
        const parentOffsetTop = parentDiv.offsetTop;
        const offsetTop = this.shippingPaymentRefs.containerRefs.offsetTop;
        window.scrollTo(0, offsetTop + parentOffsetTop - buffer);
      }
      return false;
    }

    if (
      Object.keys(valid).length === 0 &&
      Object.keys(validShipping).length === 0
    ) {
      const getCity = this.state._cityList.filter(
        city => city.value === this.state._city
      );
      const { data } = this.props.dataProvinces;
      const kaCourierOption = _additionalProducts
        .filter(item => item.isSelected)
        .map(item => item.name)
        .join(" + ");
      const getTotal = _additionalProducts
        .filter(item => item.price && item.isSelected)
        .map(item => item.price)
        .reduce((a, b) => a + b, 0);
      
      const totalAddonPrice = getTotal + _shippingFee;
      const isUsingFullWallet =
        this.state._paymentType === FULLWALLET
          ? true
          : this.state.walletPayment &&
            parseFloat(this.state._kickAmount) === this._getTotalWithoutWallet()
          ? true
          : false;
      const {
        _sell: { id, asking_price, subsidy_price }
      } = this.state;
      const code = this.state._phoneSelected && this.state._phoneSelected.label;
      const number = this.state._phoneNumber;

      const facebook_ad_campaign = localStorage.getItem("facebook_ad_campaign");
      const fb_campaign_id = facebook_ad_campaign ? JSON.parse(facebook_ad_campaign, 2, null) : null
      const dataPayload = {
        shipping: {
          /*
            shipping_id should be null
            if ada perubahan di shipping user
          */
          id: this.state.addingShipping ? null : this.state._id_shipping,
          alias: this.state._alias,
          full_name: this.state._fullName,
          phone_number: `+${code.concat(number)}`,
          street_address: this.state._alamat,
          note: this.state._notes,
          country:
            this.state._countrySelected && this.state._countrySelected.code3,
          province:
            this.state._provinceSelected && this.state._provinceSelected.label,
          province_id:
            this.state._provinceSelected && this.state._provinceSelected.id,
          city: this.state._citySelected && this.state._citySelected.label,
          city_id: this.state._citySelected && this.state._citySelected.id,
          postal_code: this.state._postalCode
        },
        user_sell_id: id,
        quantity: 1,
        // discount: this.state._discount,
        // voucher_code: this.state._voucherValidated.code,
        // payment_method: isUsingFullWallet
        //   ? FULLWALLET
        //   : this.state._paymentType,
        payment_method: this.state._paymentType,
        ka_courier_price: totalAddonPrice,
        currency: "IDR",
        offer_amount: asking_price,
        unique_amount: isUsingFullWallet ? 0 : this.state._uniqueAmount,
        administration_fee: isUsingFullWallet
          ? 0
          : this.state._administrationFee,
        ka_courier_option: kaCourierOption ? kaCourierOption : "FLAT_RATE",
        // wallet_amount: isUsingFullWallet
        //   ? this._getTotalWithoutWallet()
        //   : this.state._kickAmount,
        wallet_amount: totalUsageWallet,
        subsidy_price: parseInt(subsidy_price || 0),
        point_enabled: isUseKickPoints,
        facebook_ad_campaign: fb_campaign_id ? fb_campaign_id.facebook_ad_campaign : fb_campaign_id
      };

      localStorage.removeItem("facebook_ad_campaign");

      if (this.state._voucherValidated) {
        const { code, deduct_type } = this.state._voucherValidated;
        dataPayload["voucher_code"] = code;
        switch (deduct_type) {
          case VOUCHER_PRODUCT_TYPE:
            dataPayload["discount"] = this.state._discount;
            break;
          case VOUCHER_COURIER_TYPE:
            dataPayload["ka_courier_discount"] = this.state._discount;
            break;
        }
      }
      if (this.state._paymentType === KREDIVO) {
        dataPayload["installments_type"] = this.state._installmentsType;
      }

      this.setState(
        { _processed: false, _submitPayment: true, _error: null },
        () => {
          switch (this.state._paymentType) {
            case VIRTUALACCOUNT:
              this.props.submitXenditPayment(dataPayload);
              break;
            case CREDITCARD:
            case BCA_INSTALLMENTS:
            case BCA_VA:
            case BRI_VA:
            case BCA_CREDIT_CARD:
            case PERMATA_VA:
            case BNI_VA:
            case MANDIRI_VA:
            case MANDIRI_CREDIT_CARD:
            case MANDIRI_DEBIT_CARD:
            case BNI_CREDIT_CARD:
            case BNI_DEBIT_CARD:
            case GOPAY:
              this.props.submitMidtransPayment(dataPayload);
              break;
            case KREDIVO:
              this.props.submitKredivoPayment(dataPayload);
              break;
            case AKULAKU:
              this.props.submitAkulakuPayment(dataPayload);
              break;
            case ATOME:
              this.props.submitAtomePayment(dataPayload);
              break;
            case FULLWALLET:
            default:
              this.props.submitPayment(dataPayload);
              break;
          }
        }
      );
    }
  }

  _renderActionFooter() {
    const loadingMessage = "Hold on, your order is being processed...";
    const redirectMessage =
      "You will be redirected to our payment page to complete your order.";
    if (this.state._submitPayment || this.state._shouldRedirect)
      return (
        <div>
          <p>{this.state._shouldRedirect ? redirectMessage : loadingMessage}</p>
          <Loading center />
        </div>
      );
    return (
      <Row>
        <Col xs={12} md={{ size: 8, offset: 4 }} className="button-wrapper">
          <Button
            className="btn-green bold"
            color="success"
            size="lg"
            disabled={this.props.dataPayments.voucher.isSubmit === true}
            block
          >
            LANJUTKAN PEMBAYARAN
          </Button>
        </Col>
        <Col xs="12 button-wrapper">
          <Link
            to="#"
            onClick={this.props.onCancel}
            className={classNames("pull-right link link-red", {
              "d-none": this.state._submitPayment
            })}
          >
            cancel
          </Link>
        </Col>
      </Row>
    );
  }

  /**
   * Handle validate form on local before submit into API.
   */
  _validateForm() {
    const { _error } = this.state;
    const limit = parseInt(this._getTotalWithoutWallet() - 100000);

    let errors = {};

    if (
      this.state._voucherInput !== "" &&
      this.state._voucherValidated !== null
    )
      if (
        this.state._voucherInput.toUpperCase() !==
        this.state._voucherValidated.code.toUpperCase()
      )
        errors["_voucherInput"] = [
          "Please click button CHECK to apply the voucher code"
        ];
    if (!isNumeric(Number(this.state._kickAmount)))
      errors["_kickAmount"] = ["This field must be numeric."];
    else if (
      parseInt(this.state._kickAmount) >
      parseInt(this.props.dataAuth.userdata.balance)
    )
      errors["_kickAmount"] = [
        "The amount entered may not exceed the Kick Credit."
      ];
    if ((parseInt(this.state._kickAmount) === 0) > limit) errors = {};
    else if (parseInt(this.state._kickAmount) > limit)
      errors["_kickAmount"] = [
        `The amount entered may not exceed IDR. ${convertToRupiah(limit)}`
      ];

    if (Object.keys(errors).length) {
      this.setState({
        _error: {
          errors: { ...errors },
          status_code: 422,
          message: "Harap isi semua column berbintang"
        }
      });
    }
    return errors;
  }

  _validateShipping = () => {
    const { _error } = this.state;
    let errors = {};

    if (
      this.state._alias === "" ||
      this.state._alias === undefined ||
      this.state._alias === null
    )
      errors["_alias"] = ["Please insert alias."];
    if (
      this.state._fullName === "" ||
      this.state._fullName === undefined ||
      this.state._fullName === null
    )
      errors["_fullName"] = ["Please insert recipient name."];
    if (
      this.state._phone === "" ||
      this.state._phone === undefined ||
      this.state._phone === null ||
      this.state._phoneSelected === null
    )
      errors["_phone"] = ["Please insert area code ."];
    if (
      this.state._phoneNumber === "" ||
      this.state._phoneNumber === undefined ||
      this.state._phoneNumber === null
    )
      errors["_phoneNumber"] = ["Please insert phone number."];
    else if (!isNumeric(this.state._phoneNumber))
      errors["_phoneNumber"] = ["Phone number must be numeric"];
    if (
      this.state._alamat === "" ||
      this.state._alamat === undefined ||
      this.state._alamat === null
    )
      errors["_alamat"] = ["Please insert address."];
    if (
      this.state._countrySelected === "" ||
      this.state._countrySelected === undefined ||
      this.state._countrySelected === null
    )
      errors["_country"] = ["Please choose country."];
    if (
      this.state._province === "" ||
      this.state._province === undefined ||
      this.state._province === null ||
      this.state._province == -1
    )
      errors["_province"] = ["Please choose province."];
    if (
      this.state._citySelected === "" ||
      this.state._citySelected === undefined ||
      this.state._citySelected === null
    )
      errors["_city"] = ["Please choose city."];
    if (
      this.state._postalCode === "" ||
      this.state._postalCode === undefined ||
      this.state._postalCode === null ||
      this.state._postalCode == -1
    )
      errors["_postalCode"] = ["Please insert postal code."];
    else if (!isNumeric(this.state._postalCode))
      errors["_postalCode"] = ["Postal code must be numeric."];

    if (Object.keys(errors).length) {
      this.setState({
        _error: {
          errors: { ...errors },
          errorShipping: true,
          status_code: 422,
          message: "Harap isi semua column berbintang"
        }
      });
    }

    return errors;
  };

  _renderError = () => {
    const { _error } = this.state;
    if (_error !== null) {
      switch (_error.status_code) {
        case 422:
          return (
            <Alert color="danger">
              Please check{" "}
              {_error && _error.errorShipping
                ? "your address details"
                : "your payment details"}{" "}
              and try again.
            </Alert>
          );
        case 500:
          return (
            <Alert color="danger">
              {_error.hasMessageCustom
                ? _error.message
                : "Sorry, we have a problem!. Please inform our friendly staff via Whatsapp: +6281210005425"}
            </Alert>
          );
        case 400:
          return (
            <Alert color="danger">
              {_error.message
                ? _error.message
                : "Sorry, we have a problem!. Please inform our friendly staff via Whatsapp: +6281210005425"}
            </Alert>
          );
        default:
          break;
      }
    }
    return null;
  };

  /**
   * Determine error message by property of _errors object given.
   * @param {string} name
   */
  _hasError = name => {
    if (this.state._error !== null && this.state._error.status_code === 422) {
      return (
        Object.keys(this.state._error.errors).filter(err => err === name)
          .length > 0
      );
    }
    return false;
  };

  /**
   * Handle apply voucher when button CHECK clicked.
   */
  _applyVoucher() {
    // const voucherMandiriStr = NOVEMBAZAAR_VOUCHER.toString();

    this.setState({ _error: null });

    if (this.state._voucherInput) {
      const {
        _voucherInput,
        _sell: { id, asking_price, subsidy_price }
      } = this.state;

      this.props.applyVoucher({
        code: this.state._voucherInput,
        user_sell_id: id,
        total_amount: parseFloat(asking_price) - parseInt(subsidy_price || 0)
      });
    }
  }

  _checkout() {
    const { shippingHistory } = this.props.dataPostalCode;
    if (shippingHistory.data.length !== 0) {
      this.setState({ cekShipping: true, _stillfetchCity: false });
      this.props.funcGetHistoryShipping();
    } else {
      alert("Opps.. Kami belum menyimpan data alamat Anda sebelumnya.");
    }
  }

  /**
   * Handle toggle shipping modals.
   */
  closeModalShipping() {
    this.setState({
      modalShipping: !this.state.modalShipping
    });
  }

  /*
    on Submit modal
    func to get value shipping from ModalHistoryShipping
  */
  onChooseShipping(shipping_selected) {
    this._onUmbreShippingValueChange(false);
    if (shipping_selected === "NEW_SHIPPING") {
      this.setState({
        _alias: "",
        _fullName: "",
        _phoneNumber: "",
        _alamat: "",
        _notes: "",
        _province: "",
        _countrySelected: null,
        _countryCodeSelected: null,
        _provinceSelected: null,
        _citySelected: null,
        _postalCode: "",
        _stillfetchCity: false,
        _city: "",
        _id_shipping: "",
        addingShipping: true,
        _umbreEnabled: false,
        _error: "",
        _phoneSelected: null
      });
    } else {
      const codeArea = this.state._phoneList.find(
        item => item.label == parsePhoneCode(shipping_selected.phone_number)
      );

      this.setState(
        {
          _alias: shipping_selected.alias || "",
          _fullName: shipping_selected.full_name,
          _phoneNumber:
            shipping_selected.phone_number &&
            parsePhone(
              shipping_selected.phone_number,
              true,
              codeArea && codeArea.label
            ),
          _alamat: shipping_selected.street_address,
          _notes: shipping_selected.note,
          _countryCodeSelected: shipping_selected.country,
          _province: shipping_selected.province,
          _postalCode: shipping_selected.postal_code,
          _stillfetchCity: true,
          _city: shipping_selected.city,
          _id_shipping: shipping_selected.id,
          addingShipping: false,
          _error: "",
          _phoneSelected: codeArea
        },
        () => {
          //build country options
          this._buildCountryOptions();
          // this._calculateShippingFee(this._getProvinceId());
        }
      );
    }
    this.closeModalShipping();
  }

  /**
   * Handle clear voucher when button clear clicked.
   * @param e
   */
  _handleClearVoucher(e) {
    e.preventDefault();
    const {
      _sell: { asking_price },
      _paymentType,
      _shippingFee
    } = this.state;
    this.setState({
      _administrationFee: this._getAdmFee(
        _paymentType,
        asking_price,
        _shippingFee,
        0
      ),
      creditDebitOnly: false,
      _discount: 0,
      _isValidVoucher: false,
      _voucherValidated: null,
      _voucherInput: ""
    });
  }

  _renderAnotherAddressOptionBtn() {
    const { data } = this.props.dataPostalCode.shippingHistory;
    if (data.length) {
      return (
        <Row>
          <Col>
            <div className="user__other_shipping">
              <p
                style={{
                  color: "#169952",
                  fontWeight: 600,
                  textDecoration: "underline",
                  cursor: "pointer"
                }}
                onClick={() => this._checkout()}
              >
                Pilih Alamat Lain
              </p>
            </div>
          </Col>
        </Row>
      );
    }
    return null;
  }

  render() {
    return (
      <div className="main-container">
        <ModalSnapPay
          autoOpenSnapModal
          isCloseable={this.state._paymentType === CREDITCARD}
          isOpen={this.state._snapPay.isOpen}
          invoiceNumber={this.state._snapPay.invoiceNumber}
          trxToken={this.state._snapPay.trxToken}
          redirectUrl={this.state._snapPay.snapUrl}
          expiredAt={this.state._snapPay.expiredAt}
          onToggle={() =>
            this.props.history.replace(this.state._snapPay.redirectUrl)
          }
        />
        <ModalOutOfStock
          isCloseable
          isOpen={this.state.isOpenOutOfStockModal}
          onToggle={this._toggleModalStock}
          message={OUT_OF_STOCK_MSG}
          buttonPrimaryText={"CHECK AVAILABLE SIZES"}
          onButtonPrimaryClick={() => {
            const { id, slug } = this.props.product;
            // this.props.history.replace(`/sneakers/${id}/${slug}`);
            window.location.reload();
          }}
        />
        <ModalOutOfStock
          isCloseable
          isOpen={this.state.openModal}
          onToggle={this.toggleModalStock}
          message={PRICE_CHANGED_MSG}
          buttonPrimaryText={"GOTCHA!"}
          onButtonPrimaryClick={this.toggleModalStock}
        />
        <ModalAlert
          onToggle={this.toggleModalAlert}
          isOpen={this.state.openModalAlert}
          contentText="Your kick credit is not enough. Please choose payment method to complete the payment."
        />
        <UserBalanceInfoModal
          isOpenModalInfo={this.state.isOpenModalInfo}
          onToggle={this.onToggleBalanceInfo}
        />

        <Col xs={12} sm={12} md={12}>
          <SneakerInfoSection
            {...this.props}
            onHandleSize={this.props.submitSize}
            dataAvailableSize={this.props.dataAvailableSize}
          />
          <BottomSection
            {...this.props}
            ref={ref => (this.shippingPaymentRefs = ref)}
            showSnapPayButton={this.state._showSnapPay}
            _getLayananPrice={this._getLayananPrice}
            _kickAmount={this.state._kickAmount}
            _paymentType={this.state._paymentType}
            _getTotal={this._getTotal}
            _getWalletValue={this._getWalletValue}
            _handleSelectPhoneChange={this._handleSelectPhoneChange}
            _phone={this.state._phone}
            _phoneSelected={this.state._phoneSelected}
            _phoneList={this.state._phoneList}
            _handleSelectCountryChange={this._handleSelectCountryChange}
            _country={this.state._country}
            _countrySelected={this.state._countrySelected}
            _countryList={this.state._countryList}
            _handleSelectProvinceChange={this._handleSelectProvinceChange}
            _province={this.state._province}
            _provinceSelected={this.state._provinceSelected}
            _provinceList={this.state._provinceList}
            _handleSelectCityChange={this._handleSelectCityChange}
            _city={this.state._city}
            _citySelected={this.state._citySelected}
            _cityList={this.state._cityList}
            _handleChange={this._handleChange}
            _updateState={this._updateState}
            _installmentsType={this.state._installmentsType}
            _installmentsList={this.state._installmentsList}
            _handleKickAmount={this._handleKickAmount}
            _handlePaymentTypeChange={this._handlePaymentTypeChange}
            _setPaymentType={value => this.setState({ _paymentType: value })}
            walletPayment={this.state.walletPayment}
            _handleWalletPaymentCheckedChange={
              this._handleWalletPaymentCheckedChange
            }
            _getTotalWithoutWallet={this._getTotalWithoutWallet}
            _hasError={this._hasError}
            _error={this.state._error}
            _voucherInput={this.state._voucherInput}
            _isValidVoucher={this.state._isValidVoucher}
            _applyVoucher={this._applyVoucher}
            creditDebitOnly={this.state.creditDebitOnly}
            _handleClearVoucher={this._handleClearVoucher}
            _id_shipping={this.state._id_shipping}
            _alias={this.state._alias}
            _fullName={this.state._fullName}
            _phoneNumber={this.state._phoneNumber}
            _alamat={this.state._alamat}
            _notes={this.state._notes}
            _postalCode={this.state._postalCode}
            onChooseShipping={this.onChooseShipping}
            _handleUmbreShippingCheckedChange={
              this._handleUmbreShippingCheckedChange
            }
            _handleAdditionalChange={this._handleAdditionalChange}
            _additionalProducts={this.state._additionalProducts}
            _isPickGoodDay={this.state._isPickGoodDay}
            umbreShipping={this.state.umbreShipping}
            latestShipping={this.props.latestShipping}
            _shippingFee={this.state._shippingFee}
            _discount={this.state._discount}
            _productPromo={this.state._productPromo}
            _balanceUser={this.state._balance}
            sellerCredit={this.state.sellerCredit}
            kickPoints={this.state.kickPoints}
            sellerCreditUsage={this.state.sellerCreditUsage}
            balanceUsage={this.state.balanceUsage}
            isCreditUse={this.state.isCreditUse}
            isUseKickPoints={this.state.isUseKickPoints}
            kickPointsUsage={this.state.kickPointsUsage}
            _askingPrice={this.state._sell.asking_price}
            _submitPayment={this.state._submitPayment}
            // _toa = {this.state._toa}
            _renderError={this._renderError}
            _onSubmit={this._onSubmit}
            _umbreEnabled={this.state._umbreEnabled}
            // _handleChangeTerms = {this._handleChangeTerms}
            _shouldRedirect={this.state._shouldRedirect}
            _askingPriceStatus={this.state._askingPriceStatus}
            //category
            category={this.props.dataCategory.selected.toLowerCase()}
            isErrorShippingFetch={this.state._isErrorShippingFetch}
            onRetryCalculateShippingFee={this._handleOnRetryCalculateShippingFee}
            _handleKickPointCheckedChange={this._handleKickPointCheckedChange}
            _handleBalanceUsage={this._handleBalanceUsage}
            onToggleBalanceInfo={this.onToggleBalanceInfo}
          />

          <div
            id="social-content-mobile"
            className="social-content d-block d-sm-none"
          >
            <ShareSocialSection onModalLine={this.props.onModalLine} />
          </div>
        </Col>
      </div>
    );
  }
}
Detail.propTypes = {
  allow: propTypes.bool,
  dataAuth: propTypes.object,
  installments: propTypes.object,
  product: propTypes.object,
  sell: propTypes.object,
  onCancel: propTypes.func.isRequired,
  onModalLine: propTypes.func
};
Detail.defaultProps = {
  allow: false,
  product: {
    id: 0,
    product_variant_images: []
  },
  sell: {
    id: 0
  }
};

const mapStateToProps = state => ({
  dataCountries: state.dataPostalCode.countries,
  dataProvinces: state.dataPostalCode.provinces,
  dataCities: state.dataPostalCode.cities,
  dataCouriers: state.dataPostalCode.couriers,
  dataPostalCode: state.dataPostalCode,
  dataPayments: state.dataPayment,
  dataAuth: state.dataAuth,
  dataCategory: state.dataCategory,
  voucherCode: state.dataPayment.voucherCode,
  currency: state.dataAuth.userCurrency.currency,
  productAddon: state.dataPayment.productAddon
});

const mapDispatchToProps = dispatch => ({
  getCountries: () => dispatch(doFetchCountries()),
  getProvinces: country => dispatch(doFetchProvinces(country)),
  getCities: (country = "", province = "") =>
    dispatch(doFetchCities(country, province)),
  getShippingFee: payload => dispatch(doPostShippingCost(payload)),
  submitPayment: payload => dispatch(doPostPayments(payload)),
  submitXenditPayment: payload => dispatch(doPostXenditPayment(payload)),
  submitMidtransPayment: payload => dispatch(doPostMidtransPayment(payload)),
  submitKredivoPayment: payload => dispatch(doPostKredivoPayment(payload)),
  //TODO: Akulaku
  submitAkulakuPayment: payload => dispatch(doPostAkulakuPayment(payload)),
  submitAtomePayment: payload => dispatch(doPostAtomePayment(payload)),
  applyVoucher: payload => dispatch(doPostApplyVoucher(payload)),
  doGetVoucherCode: keyword => dispatch(doGetVoucherCode(keyword)),
  doFetchProductAddon: payload => dispatch(doFetchProductAddon(payload)),
  getProfile: () => dispatch(doFetchProfile())
});

export default connect(mapStateToProps, mapDispatchToProps)(Detail);
